import React, { useState } from 'react'
import { Select } from 'antd'
import dayjs from 'dayjs'

import { getAllTzs, tzOffsetGuess } from '@/utils/DateHelpers'

export default function TimezoneSelect({ selected, onChange, ...otherOptions }) {
    const [tzNames] = useState(getAllTzs())

    return (
        <Select
            style={{ width: '100%' }}
            options={tzNames.map((tz) => ({
                label: `${tz.name} (${tz.offset})`,
                value: `${tz.name} (${tz.offset})`,
            }))}
            value={selected ? `${selected} ${dayjs().tz(selected).format('Z')}` : null}
            onChange={(value) => onChange(value?.split(' ')[0])}
            showSearch
            allowClear
            placeholder={`Automatic : ${tzOffsetGuess()}`}
            {...otherOptions}
        />
    )
}
